export enum Browser {
  Chrome = 'Chrome',
  Safari = 'Safari',
  Firefox = 'Firefox',
  OmniWeb = 'OmniWeb',
  Opera = 'Opera',
  Edge = 'Edge',
  iCab = 'iCab',
  Konqueror = 'Konqueror',
  Camino = 'Camino',
  Netscape = 'Netscape',
  Mozilla = 'Mozilla',
  IE = 'IE',
  Other = 'Other',
}

const dataBrowser = [
  {
    string: navigator.userAgent,
    subString: 'Chrome',
    identity: Browser.Chrome,
  },
  {
    string: navigator.userAgent,
    subString: 'OmniWeb',
    versionSearch: 'OmniWeb/',
    identity: Browser.OmniWeb,
  },
  {
    string: navigator.vendor,
    subString: 'Apple',
    identity: Browser.Safari,
    versionSearch: 'Version',
  },
  // {
  //     prop: window.opera,
  //     identity: "Opera",
  //     versionSearch: "Version"
  // },
  {
    string: navigator.vendor,
    subString: 'iCab',
    identity: Browser.iCab,
  },
  {
    string: navigator.vendor,
    subString: 'KDE',
    identity: Browser.Konqueror,
  },
  {
    string: navigator.userAgent,
    subString: 'Firefox',
    identity: Browser.Firefox,
  },
  {
    string: navigator.vendor,
    subString: 'Camino',
    identity: Browser.Camino,
  },
  {
    // for newer Netscapes (6+)
    string: navigator.userAgent,
    subString: 'Netscape',
    identity: Browser.Netscape,
  },
  {
    string: navigator.userAgent,
    subString: 'MSIE',
    identity: Browser.IE,
    versionSearch: 'MSIE',
  },
  {
    string: navigator.userAgent,
    subString: 'Gecko',
    identity: Browser.Mozilla,
    versionSearch: 'rv',
  },
  {
    // for older Netscapes (4-)
    string: navigator.userAgent,
    subString: 'Mozilla',
    identity: Browser.Netscape,
    versionSearch: 'Mozilla',
  },
];

export function detectBrowser(): Browser {
  // eslint-disable-next-line no-restricted-syntax
  for (const data of dataBrowser) {
    if (data.string.indexOf(data.subString) !== -1) {
      return data.identity;
    }
  }
  return Browser.Other;
}
